import { selector } from '@/lib/selectors';
import { BankFeedState, BankFeedUserPermissionsRecord } from '@/domain/bankFeed/types';

type RootState = {
  bankFeed: BankFeedState;
};

const bankFeed = (state: RootState): BankFeedState => state.bankFeed;

export const bankFeedUserPermissionsSelector = selector<RootState, BankFeedUserPermissionsRecord>(
  bankFeed,
  (b: BankFeedState) => b.get('userPermissions'),
);

export const bankFeedUserPermissionsLoadedSelector = selector<RootState, boolean>(
  bankFeed,
  (b: BankFeedState) => b.get('userPermissionsLoaded'),
);
